export enum ProductMasterFields 
{
    ProductId ='productid', 
    IhdId ='ihdid', 
    Description ='description', 
    Sku ='sku', 
    Upc ='upc', 
    Barcode ='barcode', 
    CasepackID ='casepackid', 
    CatalogueID ='catalogueid', 
    ProductUnitCode ='productunitcode', 
    ProductUnitName ='productunitname', 
    LabelCode ='labelcode', 
    LabelName ='labelname', 
    ProductCategory ='productcategory', 
    ProductSubCategory ='productsubcategory', 
    Industry ='industry', 
    
    // Product Life Cycle
    ProductStatus ='productstatus', 
    LaunchDate ='launchdate', 
    StreetDate ='streetdate', 
    ReleaseDate ='releasedate', 
    LifecycleID ='lifecycleid', 
    ProductLifeCycle ='productlifecycle', 
    PreAwarenessDate ='preawarenessdate', 
    ShelfLife ='shelflife', 
    DiscontinuationDate ='discontinuationdate',
    Active = 'active',
    ISORDERABLE = 'isOrderable',
  
    // Inventory and Stock
    ReorderQuantity ='reorderquantity', 
    MaximumOrderQuantity ='maximumorderquantity', 
    MinimumOrderQuantity ='minimumorderquantity', 
    LeadTime ='leadtime', 
    MaximumInventoryLevel ='maximuminventorylevel', 
    SubstituteProducts ='substituteproducts', 
    InventoryType ='inventorytype', 
    Diminishing ='diminishing', 
    Medium ='medium', 
  
    // Pricing Manager
    Msrp ='msrp', 
    WholsalePrice ='wholsaleprice', 
    PartnerCost ='partnercost', 
    PartnerPrice ='partnerprice', 
    RetailPrice ='retailprice', 
    DiscountRate ='discountrate', 
    TaxRate ='taxrate', 
  
    // Product Details
    Title ='title', 
    VendorProductCode ='vendorproductcode', 
    VendorProductID ='vendorproductid', 
    Artist ='artist', 
    Comments ='comments', 
    Season ='season', 
    SeasonCode ='seasoncode', 
    CasePack = 'casepack',
    CasePackStatus = 'casepackstatus',

  
    // Supplier Information
    PreferredVendor ='preferredvendor', 
    ManufacturerCode ='manufacturercode', 
    VendorName ='vendorname', 
    ManufacturerProductName ='manufacturerproductname', 
    ManufacturerName ='manufacturername', 
  
    // Regulatory and Sales
    ExpiryDate ='expirydate', 
    TaxExmpt ='taxexmpt', 
    TaxExemptId ='taxexemptid', 
    OrderMultiples ='ordermultiples', 
  
    // Logistics and Shipping
    ReplenishmentFrequency ='replenishmentfrequency', 
    UnitOfMeasurement ='unitofmeasurement', 
    CaseSize ='casesize', 
    Family = 'family'
}

export enum ProductTabs {
    InventoryAndStock = 'Inventory And Stock',
    LogisticsAndShipping = 'Logistics And Shipping',
    PricingManager = 'Pricing Manager',
    ProductDetails = 'Product Details',
    ProductLifeCycle = 'Product LifeCycle',
    RegulatoryAndSales = 'Regulatory And Sales',
    SupplierInformation = 'Supplier Information'
  }